import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { endpoints } from '../../utils/endpoints';
import { DepositAccountRequest } from '../models/api/wallet.request';
import {
    TransferType,
    WithdrawalRequestStatusType,
} from '../models/enums/wallet.enum';
import {
    WalletPaymentAccount,
    WalletPaymentTransaction,
    WithdrawalRequest,
    WithdrawalRequestsWithPagination,
} from '../models/wallet.interface';
import { Observable } from 'rxjs';
import { ConsoleLoggerService } from '../../shared/services/console-logger.service';

@Injectable({
    providedIn: 'root',
})
export class WalletService {
    private http = inject(HttpClient);
    private logger = inject(ConsoleLoggerService);


    fetchCryptoWallet(profileId: string): Observable<any> {
        return this.http.get<any>(
            endpoints.walletAccounting.children.getConnectedCryptoWallet(
                profileId
            )
        )

    };
    connectCryptoWallet(cryptoWalletNetwork: string,
                        cryptoWalletAddress: string,
                        cryptoWalletChainId: string | null,
                        cryptoWalletName: string,
                        profileId: string): Observable<any> {
        return this.http.post<any>(
            endpoints.walletAccounting.children.connectCryptoWallet(
                profileId
            ), {
                cryptoWalletNetwork: cryptoWalletNetwork,
                cryptoWalletAddress: cryptoWalletAddress,
                cryptoWalletChainId: cryptoWalletChainId,
                cryptoWalletName: cryptoWalletName,
            }
        )
    };
    disconnectCryptoWallet(profileId: string,walletId: string){
        let params = new HttpParams();
        params = params.append('walletId', walletId);
        return this.http.patch<any>(
            endpoints.walletAccounting.children.disconnectCryptoWallet(
                profileId
            ),{profileId: profileId, walletId: walletId}, {params}
        )
    };


    fetchPaymentAccounts(playerId: string) {
        return this.http.get<WalletPaymentAccount[]>(
            endpoints.walletAccounting.children.getProfilePaymentAccountUrl(
                playerId
            )
        );
    }
    fetchTeamWallet(teamId: string) {
        return this.http.get<WalletPaymentAccount>(
            endpoints.walletAccounting.children.getTeamWallet(
                teamId
            )
        );
    }


    fetchWalletTransactions(accountId: string, transferType?: TransferType) {
        let params = new HttpParams();

        if (transferType) {
            params = params.append('transferType', transferType);
        }

        return this.http.get<WalletPaymentTransaction[]>(
            endpoints.walletAccounting.children.getWalletTransactionsUrl(
                accountId
            ),
            {
                params,
            }
        );
    }  ;
    fetchLPWalletTransactions(accountId: string, transferType?: TransferType) {
        let params = new HttpParams();

        if (transferType) {
            params = params.append('transferType', transferType);
        }

        return this.http.get<WalletPaymentTransaction[]>(
            endpoints.walletAccounting.children.getLPTransactionsUrl(
                accountId
            ),
            {
                params,
            }
        );
    }

    depositAccount({ profileId, ...requestData }: DepositAccountRequest) {
        return this.http.patch<WalletPaymentTransaction>(
            endpoints.walletAccounting.children.depositAccount(profileId),
            requestData
        );
    }

    sendWithdrawalRequest(
     payload: any
    ) {
        // this.logger.info('Wallet', 'sendWithdrawalRequest - actual BE REQUEST', { body: payload });
        return this.http.post(
            endpoints.walletAccounting.children.sendWithdrawalRequest(
                payload.profileId
            ),
            payload
        );
    }

    fetchWithdrawalRequests(status?: WithdrawalRequestStatusType) {
        let params = new HttpParams();

        if (status) {
            params = params.append('Filters', `status==${status}`);
            //TODO use pagination instead of hardcoded value.
            params = params.append('PageSize', '99999999');
        }

        return this.http.get<WithdrawalRequestsWithPagination>(
            endpoints.walletAccounting.children.getWithdrawalRequestsUrl(),
            { params }
        );
    }

    changeWithdrawalRequestStatus(
        profileId: string,
        requestId: string,
        status: WithdrawalRequestStatusType
    ) {
        return this.http.patch<WithdrawalRequest>(
            endpoints.walletAccounting.children.changeWithdrawalRequest(
                profileId,
                requestId,
                status
            ),
            {}
        );
    };
    //TODO: FIX ANY
    depositLP({ id, ...requestData }: any) {
        return this.http.patch<WalletPaymentTransaction>(
            endpoints.walletAccounting.children.depositLP(id),
            requestData
        );
    }

}
